/*
React-Quill v1.0.0
https://github.com/zenoamaro/react-quill
*/
var Quill = require('quill');
var Component = require('./component');

module.exports = Component;
module.exports.default = Component;
module.exports.Quill = Quill;
module.exports.Mixin = require('./mixin');
module.exports.Toolbar = require('./toolbar');



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-quill/lib/index.js
 ** module id = 2874
 ** module chunks = 0
 **/